
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/pickup/ford-f-150",
      function () {
        return require("private-next-pages/rims/pickup/ford-f-150.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/pickup/ford-f-150"])
      });
    }
  